import { render, staticRenderFns } from "./BillsNotifyPreview.vue?vue&type=template&id=4b41768f&"
import script from "./BillsNotifyPreview.js?vue&type=script&lang=js&"
export * from "./BillsNotifyPreview.js?vue&type=script&lang=js&"
import style0 from "./BillsNotifyPreview.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports